module.exports = __webpack_public_path__ + "static/media/rocket.e2309af0.svg";